import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteItem, fetchData, toggleStatus } from "../../../utils/apiUtils";
import DeleteModel from "../../../Components/DeleteModel";
import {
  ActionButton,
  checkImage,
  ToggleSwitch,
} from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import Breadcrumb from "../../../helper/Breadcrumb";
import { PlusButton } from "../../../helper/ImageFormat";
import Spinner from "../../../Components/spinner";
import TableSearch from "../../../Components/TableSearch";
import PerPageSelect from "../../../Components/PerPageSelect";
import dateformate from "../../../helper/DateFormate";

const Pagewisebanner = () => {
  const [loading, setLoading] = useState(false);
  const [sliderData, setSliderData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
   const [search, setSearch] = useState("");
  const navigator = useNavigate();
  const [perPage, setPerPage] = useState(10);
  const totalPages = Math.ceil(totalCount / perPage);
 
  const fetchPageBanner = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      search: searchQuery,
    };
    await fetchData(
      "pagebanner-pagination",
      requestData,
      setSliderData,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };


  useEffect(() => {
          const delay = search ? 500 : 0;
          const handler = setTimeout(() => {
          fetchPageBanner(currentPage, search);
          }, delay);
          return () => clearTimeout(handler);
      }, [search, perPage]);


  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchPageBanner(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };


  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("pagebanner", deleteItemId?.id, fetchPageBanner,[deleteItemId?.desktopImage, deleteItemId?.mobileImage].filter(Boolean));
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };



  const handleStatusToggle = async (item) => {
    const data = await toggleStatus("pagebanner-status", item?.id);
    if (Object.keys(data).length > 0) {
      setSliderData((prevdata) =>
        prevdata.map((curr) =>
          curr.id === data.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const handleEditClick = (item) => {
    navigator("/add-page-banner", {
      state: item,
    });
  };

  const handleAdd = () => {
    navigator("/add-page-banner");
  };

  const Tableheader = [
    "Page Name",
    "Title",
    "Desktop Img",
    "Mobile Img",
    "Type",
    "Updated At",
    "Is Active",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Page-Banners", path: "/page-banner" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Page Banners</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

<div className="d-flex justify-content-between mb-2 bg-white p-2" style={{ marginTop: "-20px" }}>
            <PerPageSelect value={perPage} onChange={setPerPage}/>
                <div style={{ display: "flex", gap: "10px" }}>
            <TableSearch value={search} onChange={setSearch} />
        <PlusButton handleAdd={handleAdd} module={"Page banners"} />
                </div>
        </div>


        

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive ">
                  <table
                    className=" custom-table table table-striped"
                    id="pagewiseBannerTable"
                  >
                    <thead>
                      <tr>
                        {Tableheader &&
                          Tableheader.length > 0 &&
                          Tableheader.map((item, index) => (
                            <th className="font-weight-bold" key={index}>
                              {item}
                            </th>
                          ))}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : sliderData.length > 0 ? (
                        sliderData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item?.menu?.label}</td>
                              <td>{item?.title}</td>
                              <td >
                                {checkImage(item.desktopImage)}
                              </td>
                              <td >
                                {checkImage(item?.mobileImage)}
                              </td>
                              <td>{item?.bannerType}</td>
                              <td>{dateformate(item.updatedAt)}</td>
                              <td >
                                <ToggleSwitch
                                  data={item}
                                  name="isActive"
                                  checked={item.isActive}
                                  handleStatusToggle={handleStatusToggle}
                                  module={"Page banners"}
                                />
                              </td>

                              <td >
                                <ActionButton
                                  data={item}
                                  handleEditClick={handleEditClick}
                                  handleDelete={handleDelete}
                                  module={"Page banners"}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {sliderData.length > 0 && (
                  <div>
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="pagewise banner"
            module={"Page banners"}
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default Pagewisebanner;
